import { MutationTree } from 'vuex';
import { RootState } from '../types';
import { StoreMutations } from '@/templates/DataNames';
import Vue from 'vue';
import { addUniqExamplesId, createBreadcrumbs, parseDataWithCurrentLang } from '@/heplers/index';

export const mutations: MutationTree<RootState> = {
  [StoreMutations.TREE]: (state, tree) => {
    Object.values(tree).forEach(
      (item: any, i: string | number) => item && Vue.set(state.tree, i, item)
    );
    state.treeLoading = false;
  },
  [StoreMutations.CONTENT]: (state, content) => {
    const parsedContent = parseDataWithCurrentLang(content);

    state.content = addUniqExamplesId(parsedContent);
    state.contentLoading = false;
  },

  [StoreMutations.COUNTRY_CODE]: (state, country_code) => {
    state.country_code = country_code;
  },

  [StoreMutations.ROOT_NAMES]: (state, content) => {
    state.rootNames = content;
  },
  // Мутируем весь обьект выбранных языков (вытаскиваем из localStorage)
  [StoreMutations.SET_LANGUAGES]: (state, languages) => {
    state.selectedLanguagesPack = languages;
  },
  [StoreMutations.SET_RENDER_PAGE_STATUS]: (state: RootState, bool: boolean) => {
    state.pageRendered = bool;
  },
  [StoreMutations.SET_CURRENT_LANG]: (state, lang) => {
    if (!lang) return;

    state.selectedLang = lang === 'c#' ? 'csharp' : lang.replace(/\./, '').toLowerCase();
  },
  [StoreMutations.SET_WITH_BY_LINK]: (state: RootState, bool: boolean) => {
    state.withByLink = bool;
  },
  [StoreMutations.SET_MOBILE_CODE_RAILS]: (state, bool: boolean) => {
    state.isMobileCodeRails = bool;
  },
  // Мутируем выбранный язык для текущего sdk
  [StoreMutations.UPDATE_LANGUAGES_PACK]: (state: RootState, languageContent) => {
    //  приводим название к ключу обьекта. Example: 'NODE.JS' -> nodejs
    let preparedLang = typeof languageContent === 'object' ? languageContent.lang : languageContent;

    if (!preparedLang) return;

    preparedLang = preparedLang.replace(/\./, '').toLowerCase();
    state.selectedLang = preparedLang === 'c#' ? 'csharp' : preparedLang;

    // Нужно дефолтное значение, чтобы не сломалось

    const selectedPack = languageContent.activeSdk || 'http_api';

    // Применяем выбранный язык для sdk, записываем обновленный пак в localStorage
    // @ts-expect-error: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'SelectedLanguagesPack'
    state.selectedLanguagesPack[selectedPack] = preparedLang;

    try {
      localStorage.setItem('selectedLangs', JSON.stringify(state.selectedLanguagesPack));
    } catch (e) {
      console.error('Failed to save to localStorage:');
    }
  },
  [StoreMutations.SEARCH]: (state, content) => {
    state.searchResult = content;
  },
  [StoreMutations.SET_CURRENT_LOCALE]: (state, content) => {
    state.locale = content;
  },
  [StoreMutations.BREADCRUMBS]: (state, url: string): void => {
    state.breadcrumbs = createBreadcrumbs(state.tree, url.trim());
  },
  [StoreMutations.SET_STATUS_OF_PAGEINCLUDESCODEEXAMPLES]: (state, status: boolean): void => {
    state.pageIncludesCodeExamples = status;
  },
  [StoreMutations.SET_LISTENERS_STATE]: (state, status: boolean): void => {
    state.toggleListeners = status;
  },
  [StoreMutations.SET_CURRENT_ANCHOR]: (state, status: string): void => {
    state.currentAnchor = status;
  },
  [StoreMutations.SET_MOBILE_STATE]: (state, status: boolean): void => {
    state.isMobile = status;
  },
  [StoreMutations.SET_PROGRESSBAR_STATUS]: (state, status: boolean): void => {
    state.progressBarStatus = status;
  },
  [StoreMutations.SET_CONTENT_LOADING]: (state, status: boolean): void => {
    state.contentLoading = status;
  },
};
